export const labels = {
  companyName: 'Company name',
  companyRegNo: 'Company reg. no.:',
  companyVatNo: 'VAT reg. no.:',
  provider: 'Provider',
  customer: 'Customer',
  invoice: 'Invoice',
  invoiceDate: 'Invoice Date',
  invoiceNumber: 'Invoice Number',
  invoiceSeries: 'Invoice series',
  worksCompleted: 'Works completed / Services provided',
  date: 'Date',
  description: 'Description',
  qty: 'Qty',
  unit: 'Unit',
  rate: 'Rate',
  total: 'Total',
  vatBasis: 'VAT Basis',
  vatAmount: 'VAT Amount',
  vatRate: 'VAT rate',
  vatRatePct: 'VAT rate %',
  currency: 'Currency',
  vat: 'VAT',
  totalPayable: 'Total Payable',
  addNew: 'Add new row',
  invoiceMeta: 'Invoice meta',
  invoiceBranding: 'Invoice branding',
  companyId: 'Comapny ID',
  enterEntryDescription: 'Entry description',
  billingInformation: 'Billing information',
  billingBankAccountIban: 'IBAN:',
  billingBankAccountBic: 'BIC:',
  billingBankAccountNo: 'Account number:',
  billingBankAccountSortCode: 'Sort code:',
  name: 'Name',
  brandName: 'Brand name part 1',
  brandSubName: 'Brand name part 2',
  role: 'Role',
  addressLine1: 'Address Line 1',
  addressLine2: 'Address Line 2',
  addressLine3: 'Address Line 3',
  addressLine4: 'Address Line 4',

  // other interface translations
  dateFormat: 'DD/MM/YYYY',
  // show: 'Show',
  // hide: 'Hide',
  showForm: 'Show form',
  hideForm: 'Hide form',
  note: 'Note',
  createNewInvoice: 'Create new invoice',
  creatingNewInvoice: 'Creating new invoice',
  editingExistingInvoice: 'Editing existing invoice',
  saveInvoice: 'Save invoice',
  lock: 'Lock',
  unlock: 'Unlock',
  deleteInvoice: 'Delete invoice',
  companyDetails: 'Company details',
  representativeDetails: 'Representative details',
  companyAddress: 'Company address',
  billingInfo: 'Billing info',
  isClientVatRegistered: 'Is client VAT registered?',
  prefillCustomer: 'Prefill',
  selectExistingCustomer: 'Select from existing customers',
  showingCustomersWithDetails: 'Showing customers that have "Address Line 1" present.',
}